import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';


const InquiryCard = ({ inquiry, onViewDetails, onRespond }) => {
  const formatBudget = (min, max, currency) => {
    if (!min && !max) return 'Budget not disclosed';
    if (min && max) return `€${min}M - €${max}M`;
    if (min) return `From €${min}M`;
    return `Up to €${max}M`;
  };

  const formatDeadline = (deadline) => {
    if (!deadline) return 'No deadline';
    const date = new Date(deadline);
    const daysLeft = Math.ceil((date - new Date()) / (1000 * 60 * 60 * 24));
    if (daysLeft < 0) return 'Expired';
    if (daysLeft === 0) return 'Today';
    if (daysLeft === 1) return 'Tomorrow';
    return `${daysLeft} days left`;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'open': return 'bg-success/10 text-success';
      case 'in_negotiation': return 'bg-accent/10 text-accent';
      case 'closed': return 'bg-muted text-muted-foreground';
      case 'expired': return 'bg-destructive/10 text-destructive';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-lg transition-all duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <span className={`px-2 py-1 rounded text-xs font-medium ${getStatusColor(inquiry?.status)}`}>
              {inquiry?.status?.replace('_', ' ')?.toUpperCase()}
            </span>
            {inquiry?.responsesCount > 0 && (
              <span className="text-xs text-muted-foreground flex items-center gap-1">
                <Icon name="MessageSquare" size={12} />
                {inquiry?.responsesCount} responses
              </span>
            )}
          </div>
          <h3 className="text-lg font-bold text-foreground mb-2">{inquiry?.title}</h3>
          <p className="text-sm text-muted-foreground line-clamp-2 mb-3">{inquiry?.description}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Target" size={16} color="var(--color-primary)" />
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Position</div>
            <div className="text-sm font-medium text-foreground">{inquiry?.positionRequired}</div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center">
            <Icon name="DollarSign" size={16} color="var(--color-success)" />
          </div>
          <div>
            <div className="text-xs text-muted-foreground">Budget</div>
            <div className="text-sm font-medium text-foreground">{formatBudget(inquiry?.budgetMin, inquiry?.budgetMax, inquiry?.currency)}</div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between pt-4 border-t border-border">
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-1">
            <Icon name="Building" size={12} />
            <span>{inquiry?.club?.organization || inquiry?.club?.full_name || 'Club'}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Clock" size={12} />
            <span>{formatDeadline(inquiry?.timelineDeadline)}</span>
          </div>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={() => onViewDetails(inquiry)}>
            View Details
          </Button>
          {inquiry?.status === 'open' && (
            <Button variant="default" size="sm" onClick={() => onRespond(inquiry)} iconName="Send" iconPosition="left">
              Respond
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default InquiryCard;